import { getEventOrganizationName, isSmuinEvent } from './eventOrganization';
import { normalizeCityName } from './eventLocationDisplay';

export function getEventProductionName(event) {
  const originalName = String(event?.['Event Name'] || '').trim();
  return isSmuinEvent(event)
    ? originalName.replace(/\s+by\s+Smuin(?:\s+Contemporary)?\s+Ballet\s*$/i, '').trim()
    : originalName;
}

export function getEventSearchTitle(event) {
  return String(event?.['Event Name'] || '').trim();
}

export function getEventSearchKeywords(event) {
  const productionName = getEventProductionName(event);
  const organizationName = getEventOrganizationName(event);
  const city = normalizeCityName(event?.Address?.city || '');
  const categories = Array.isArray(event?.categories) ? event.categories : [];
  const values = [...categories];

  if (isSmuinEvent(event)) {
    values.push(
      'Smuin Ballet',
      'Smuin Contemporary Ballet',
      productionName && `${productionName} Smuin Ballet`,
      city && `Smuin Ballet ${city}`,
      city && `${productionName} ${city}`,
      city && `contemporary ballet ${city}`,
      'contemporary ballet San Francisco Bay Area'
    );
  } else if (organizationName) {
    values.push(organizationName);
  }

  return [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];
}

export function isSameEventProgram(current, candidate) {
  if (!current || !candidate) return false;
  if (current.manualProgramId && candidate.manualProgramId) {
    return current.manualProgramId === candidate.manualProgramId;
  }
  return Boolean(
    getEventProductionName(current) &&
    getEventProductionName(current) === getEventProductionName(candidate) &&
    getEventOrganizationName(current) === getEventOrganizationName(candidate)
  );
}

export function getRelatedDatesHeading(event) {
  return `More dates for ${getEventSearchTitle(event)}`;
}
